<script>
export let color = '#FFC129'
let social = [
  {
    title: 'Facebook',
    iconHtml:
      '<svg width="13" height="25" viewBox="0 0 13 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.0122 13.6196L12.678 9.27613H8.51014V6.45757C8.51014 5.26946 9.09253 4.11136 10.9586 4.11136H12.8536V0.412555C12.8536 0.412555 11.1342 0.119141 9.49041 0.119141C6.05835 0.119141 3.8155 2.19972 3.8155 5.96521V9.27613H0V13.6196H3.8155V24.1191H8.51125V13.6196H12.0122Z" fill="' +
      color +
      '"/></svg>',
    href: 'https://www.facebook.com/missionbambini/',
  },
  {
    title: 'Instagram',
    iconHtml:
      '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.3538 4.40625C17.577 4.40625 16.9468 5.03643 16.9468 5.81331C16.9468 6.59019 17.577 7.22037 18.3538 7.22037C19.1307 7.22037 19.7609 6.59019 19.7609 5.81331C19.7609 5.03643 19.1307 4.40625 18.3538 4.40625Z" fill="' +
      color +
      '"/><path d="M12.099 6.21094C8.84032 6.21094 6.18848 8.86279 6.18848 12.1215C6.18848 15.3802 8.84032 18.032 12.099 18.032C15.3577 18.032 18.0095 15.3802 18.0095 12.1215C18.0095 8.86279 15.3577 6.21094 12.099 6.21094ZM12.099 15.907C10.0118 15.907 8.3124 14.2087 8.3124 12.1215C8.3124 10.0342 10.0106 8.33597 12.099 8.33597C14.1874 8.33597 15.8845 10.0342 15.8845 12.1215C15.8845 14.2087 14.1863 15.907 12.099 15.907Z" fill="' +
      color +
      '"/><path d="M16.7902 24.1211H7.20867C3.23423 24.1211 0 20.8869 0 16.9124V7.32976C0 3.35533 3.23423 0.121094 7.20867 0.121094H16.7902C20.7658 0.121094 23.9989 3.35533 23.9989 7.32976V16.9124C23.9989 20.888 20.7647 24.1211 16.7902 24.1211ZM7.20867 2.3795C4.47902 2.3795 2.25729 4.60012 2.25729 7.33087V16.9135C2.25729 19.6443 4.47791 21.8649 7.20867 21.8649H16.7902C19.521 21.8649 21.7416 19.6443 21.7416 16.9135V7.32976C21.7416 4.60012 19.521 2.37839 16.7902 2.37839H7.20867V2.3795Z" fill="' +
      color +
      '"/></svg>',

    href: 'https://www.instagram.com/missionbambini/',
  },
  {
    title: 'YouTube',
    iconHtml:
      '<svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 5.38771C24 2.47931 21.6418 0.121094 18.7334 0.121094H5.26662C2.35822 0.121094 0 2.47931 0 5.38771V11.654C0 14.5624 2.35822 16.9207 5.26662 16.9207H18.7334C21.6418 16.9207 24 14.5624 24 11.654V5.38771ZM16.0798 8.99066L10.041 11.9789C9.80476 12.1069 8.99973 11.9351 8.99973 11.6661V5.53318C8.99973 5.26083 9.81023 5.0891 10.0476 5.22473L15.8283 8.36938C16.0711 8.5072 16.3249 8.85831 16.0798 8.99066Z" fill="' +
      color +
      '"/></svg>',
    href: 'https://www.youtube.com/missionbambiniorg',
  },
  {
    title: 'Linkedin',
    iconHtml:
      '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.395817 8.0698H5.37533V24.0653H0.395817V8.0698ZM2.88669 0.121094C4.47889 0.121094 5.76892 1.41336 5.76892 3.00221C5.76892 4.59106 4.47889 5.88667 2.88669 5.88667C1.2945 5.88667 0 4.59329 0 3.00221C0 1.41113 1.29004 0.121094 2.88669 0.121094Z" fill="' +
      color +
      '"/><path d="M8.49512 8.06965H13.2639V10.2572H13.3297C13.9942 8.99843 15.6165 7.67383 18.0382 7.67383C23.0724 7.67383 24.0001 10.9842 24.0001 15.2925V24.0652H19.0317V16.2882C19.0317 14.4317 18.996 12.0468 16.4472 12.0468C13.8983 12.0468 13.4646 14.0671 13.4646 16.1533V24.0652H8.49512V8.06965Z" fill="' +
      color +
      '"/></svg>',

    href: 'https://www.linkedin.com/company/mission-bambini/',
  },
  {
    title: 'Twitter',
    iconHtml:
      '<svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.9013 2.48962C23.1395 2.83403 22.2962 3.04326 21.4743 3.18166C21.8648 3.11621 22.4378 2.40915 22.6674 2.12375C23.0183 1.68813 23.309 1.19136 23.4732 0.65489C23.4946 0.613045 23.5097 0.560471 23.4678 0.528283C23.4152 0.507897 23.3809 0.517554 23.3391 0.539013C22.4217 1.03149 21.4722 1.38771 20.4614 1.63985C20.3778 1.66023 20.3155 1.63985 20.2629 1.58728C20.1793 1.49286 20.1009 1.4038 20.0119 1.32977C19.587 0.968189 19.1321 0.684932 18.6181 0.475709C17.9432 0.201036 17.2061 0.084086 16.4798 0.131295C15.7727 0.177432 15.0785 0.375926 14.4519 0.704245C13.8232 1.03257 13.262 1.48964 12.8157 2.04113C12.3532 2.61086 12.0131 3.28467 11.8382 3.99817C11.6698 4.687 11.6837 5.36832 11.7867 6.06465C11.8017 6.18053 11.7921 6.19555 11.688 6.18053C7.7353 5.59256 4.45961 4.17843 1.79979 1.14737C1.68391 1.0154 1.62168 1.0154 1.52726 1.15703C0.363119 2.90163 0.927496 5.70415 2.3824 7.08073C2.5766 7.2642 2.77509 7.44767 2.98968 7.61505C2.91135 7.63115 1.94356 7.526 1.08199 7.08073C0.966109 7.00777 0.908174 7.04961 0.898518 7.18051C0.887789 7.36935 0.903887 7.54209 0.929637 7.74702C1.15281 9.51523 2.37703 11.1504 4.05404 11.7888C4.25361 11.8725 4.47356 11.9465 4.68815 11.983C4.30618 12.0667 3.91241 12.1268 2.81694 12.0409C2.68067 12.0152 2.6281 12.0828 2.68067 12.2137C3.50362 14.4583 5.28148 15.1256 6.61192 15.5065C6.79003 15.5376 6.96814 15.5376 7.14732 15.5795C7.13659 15.5956 7.12587 15.5956 7.11514 15.6106C6.67416 16.2833 5.14307 16.7844 4.42957 17.0333C3.13346 17.4872 1.72147 17.69 0.351321 17.5558C0.131368 17.5237 0.0863018 17.5258 0.0262171 17.5558C-0.0338675 17.5934 0.0187029 17.646 0.0895169 17.7018C0.367408 17.8852 0.650669 18.0483 0.93929 18.205C1.80944 18.6663 2.71608 19.0333 3.66564 19.2951C8.56468 20.6481 14.0828 19.6534 17.7619 15.999C20.6503 13.1289 21.6631 9.17082 21.6631 5.20845C21.6631 5.05394 21.8466 4.96811 21.955 4.88549C22.7071 4.32113 23.3133 3.64517 23.8734 2.8909C23.9989 2.72137 24 2.57116 24 2.50893V2.48854C24 2.42524 23.9989 2.44455 23.9013 2.48854V2.48962Z" fill="' +
      color +
      '"/></svg>',
    href: 'https://twitter.com/missionbambini/',
  },
]
</script>

<ul class="social" style="color: {color};">
  {#each social as s}
    <li>
      <a href={s.href} target="_blank" rel="noopener noreferrer" title={s.title}
        >{@html s.iconHtml}</a>
    </li>
  {/each}
</ul>

<style>
.social {
  display: flex;
  justify-content: center;
  align-items: center;
  list-style: none;
  margin-bottom: 0;
  padding-left: 0;
}

.social li {
  margin: 0;
}

.social a {
  display: block;
  padding: 0 0.5rem;
  color: inherit;
  text-decoration: none;
  transition: 0.3s all ease-in-out;
  cursor: pointer;
}

.social a:hover {
  transform: translate(0, -0.25rem);
}
</style>
